function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M74.155 39.06V3.852l35.208 35.208z",
    style: {
      fill: "#f6a097"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.742 3.852h54.69v34.931h34.931v86.698H19.742z",
    style: {
      fill: "#ef5848"
    }
  }));
};
export default SvgIcon;